// extracted by mini-css-extract-plugin
module.exports = {"deviceWrap":"deviceWrap_18ybxjN1"};